import React, { FC } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { CountryPreviewFragment } from "__generated__/graphql";
import { getCountryOptions } from "helpers/getCountryOptions";
import { WithLabel } from "common/fieldLabel/WithLabel";
import { checkOptionEqualToValue } from "./checkOptionEqualToValue";

export type ICountryAutoCompleteFieldValue =
  | CountryPreviewFragment[]
  | CountryPreviewFragment
  | null;

interface ICountryAutocompleteFieldProps {
  value: ICountryAutoCompleteFieldValue;
  setValue: (value: ICountryAutoCompleteFieldValue) => void;
  label?: string;
  labelledById?: string;
  errorMessage?: string;
  touched?: boolean;
  externalLabel?: boolean;
  multiple?: boolean;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}
export const CountryAutocompleteField: FC<ICountryAutocompleteFieldProps> = ({
  label = "Country",
  value,
  setValue,
  labelledById,
  externalLabel,
  errorMessage,
  multiple,
  onKeyDown,
  touched,
}) => {
  const labelId = `country_autocomplete_${label.replaceAll(" ", "_")}`;
  const countryOptions = getCountryOptions();
  const handleChangeCountry = (
    event,
    newCountry: ICountryAutoCompleteFieldValue,
  ) => {
    setValue(newCountry);
  };
  return (
    <Autocomplete
      isOptionEqualToValue={checkOptionEqualToValue}
      options={countryOptions}
      autoHighlight
      filterSelectedOptions
      getOptionLabel={(option: CountryPreviewFragment) => option.name}
      renderOption={(props, option: CountryPreviewFragment) => (
        <li {...props} data-cy={option.name}>
          {option.emojiFlag} {option.name} ({option.code})
        </li>
      )}
      multiple={multiple}
      value={value}
      onChange={handleChangeCountry}
      renderInput={(params) => (
        <WithLabel
          externalLabel={externalLabel}
          label={label}
          labelId={labelId}
        >
          <TextField
            {...params}
            label={externalLabel ? "" : label}
            variant="outlined"
            size="small"
            fullWidth
            inputProps={{
              ...params.inputProps,
              autoComplete: "off",
            }}
            InputProps={{
              ...params.InputProps,
            }}
            error={touched && errorMessage ? true : false}
            helperText={errorMessage}
            data-cy="country"
            aria-labelledby={externalLabel ? labelId : labelledById}
            placeholder="Select country"
            onKeyDown={onKeyDown}
          />
        </WithLabel>
      )}
    />
  );
};
